import { addDays } from 'date-fns';
import { numberLocale } from './numberFormat';
import { weekStartIsoToDate } from './hseWeek.util';

/** "25 Oct – 31 Oct 2026" in the UI language (Latin digits, as elsewhere in the app). */
export function formatWeekRange(weekStart: string, lang: string): string {
  const start = weekStartIsoToDate(weekStart);
  if (!start) return weekStart;
  const end = addDays(start, 6);
  const locale = numberLocale(lang);
  const dayMonth = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' });
  const full = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short', year: 'numeric' });
  return `${dayMonth.format(start)} – ${full.format(end)}`;
}

export function formatDateTime(iso: string | null | undefined, lang: string): string {
  if (!iso) return '';
  // API timestamps are naive UTC.
  const date = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(iso) ? iso : `${iso}Z`);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat(numberLocale(lang), { dateStyle: 'medium', timeStyle: 'short' }).format(date);
}

/**
 * Unicode first-strong isolate around a value placed inside translated text, so a
 * Latin username or a date keeps its own direction inside an Arabic/Urdu sentence.
 */
export function isolate(value: string): string {
  return `⁨${value}⁩`;
}
